/**
 * Layout Reasoning Engine — which layout serves the direction, and why.
 *
 * The reasoning matters as much as the answer: each recommendation carries
 * the designer's rationale in plain language, which is what gets shown to
 * admins and (later) fed back to OpenAI so it can argue with the choice.
 * The recommended layout is always a real Template Factory layout gene.
 */

import { FLOWS } from './movementEngine';

/**
 * Recommend a layout for the direction.
 * Returns { recommendedLayout, alternatives[], reasoning[] }.
 */
export const reasonLayout = ({ flow, composition, focus, audience }) => {
  const reasoning = [];
  const recommendedLayout = flow.factoryLayout;

  reasoning.push(
    `The ${flow.name} reading path needs a layout that supports it — "${recommendedLayout}" places content along that path.`
  );

  if (composition.heroAreaRatio >= 0.45) {
    reasoning.push(
      `Hero at ${Math.round(composition.heroAreaRatio * 100)}% of canvas wants a top- or side-anchored hero zone.`
    );
  }
  if (focus.primary === 'offer') {
    reasoning.push('Offer is the focal point — layouts that lift the offer above the fold rank higher.');
  }
  if (audience.readingHabit === 'text-first') {
    reasoning.push('Text-first audience — generous text zones beat image real estate.');
  }

  // Alternatives: other layouts whose flows sit adjacent in energy.
  const alternatives = [...new Set(
    Object.values(FLOWS)
      .filter((f) => f.id !== flow.id && f.endpoint === flow.endpoint)
      .map((f) => f.factoryLayout)
  )].filter((l) => l !== recommendedLayout);

  return { recommendedLayout, alternatives, reasoning };
};
